const setEmptySeatOfCounts = (columns, columnCount) =>
  Array(columnCount)
    .fill()
    .map((_, i) => columns[i]);

export default setEmptySeatOfCounts;
